import React from 'react';
import camelCase from 'lodash/camelCase';
import { PapiDacheckoutCorePackages } from '@wix/da-papi-types';
import TextTooltipOnHover from '@wix/da-shared-react/pkg/Popover/Preset/TextTooltipOnHover';
import InfoIcon from '@wix/da-ds/pkg/Icons/16x16/Info';
import BenefitField from './_partials/BenefitField';
import { usePackagePickerOrder } from '../../../../../hooks';

import s from '../../HeroTableDesktop.scss';

interface Props {
  className?: string;
  highlightPackage?: React.ReactNode;
  packageBenefit: Unpacked<PapiDacheckoutCorePackages['packageBenefits']>;
}

const PackageBenefitsSection: React.FC<Props> = ({
  className,
  highlightPackage,
  packageBenefit,
}) => {
  const packagePickerOrder = usePackagePickerOrder();
  const packagePickerOrderCamelCase = packagePickerOrder.map(p => camelCase(p));
  const sectionTitle = packageBenefit?.title || '';
  const benefits = packageBenefit?.benefits || [];
  return (
    <div className={className}>
      {sectionTitle && (
        <div className={s['frame-wrapper']}>
          <div className={s['mid-table']}>
            <div className={s['mid-table-header']}>{sectionTitle}</div>
          </div>
        </div>
      )}

      <div className={s['frame-wrapper']}>
        {highlightPackage}
        <table className={s['hero-table']}>
          <tbody>
            {benefits.map(({ title, tooltipMessage, values }, index) => {
              // if any of the packages is missing from the benefit - bail early
              if (
                packagePickerOrderCamelCase.some(coreType => !values[coreType])
              ) {
                return null;
              }
              return (
                <tr key={index}>
                  <th className={s['header-column']}>
                    <div className={s['header-layout']}>
                      <div>{title}</div>
                      {tooltipMessage && (
                        <TextTooltipOnHover tooltipText={tooltipMessage}>
                          <InfoIcon
                            className={s['info']}
                            customSizable
                            disableDefaultColors
                          />
                        </TextTooltipOnHover>
                      )}
                    </div>
                  </th>
                  {packagePickerOrderCamelCase.map(coreType => (
                    <td key={coreType} className={s[coreType]}>
                      <BenefitField
                        label={values?.[coreType].label}
                        sublabel={values?.[coreType].sublabel}
                        labelType={values?.[coreType].labelType}
                      />
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
PackageBenefitsSection.displayName = 'PackageBenefitsSection';

export default PackageBenefitsSection;
